import { styled } from 'styled-components';
import { toggleParentStyles } from '../../core-components';
export const Label = styled.label.withConfig({
  componentId: "aui__sc-zd1kti-0"
})(["display:inline-flex;align-items:center;box-sizing:border-box;", ";cursor:pointer;&:has(input:disabled){cursor:not-allowed;}"], toggleParentStyles);